import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { Component, OnInit, Inject, Injector } from '@angular/core';
import { UserPreferenceConstants } from 'src/app/core/constants/user-preference-constants.constant';
import { ContainerService} from '../../services/container-service.service';
import { HttpErrorResponse } from '@angular/common/http';
import { DropdownOptionsService } from 'src/app/core/services/dropdown-options.service';
import { isNullOrEmpty } from 'src/app/core/utils/common-functions';
import { strictEqual } from 'assert';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'laas-orphan-container',
  templateUrl: './orphan-container.component.html',
  styleUrls: ['./orphan-container.component.scss']
})
export class OrphanContainerComponent extends SessionBaseComponent implements OnInit {

  isLoading: boolean = false;
  readonly preferenceKey: string = UserPreferenceConstants.OrphanContainerSearch;
  readonly preferenceKey2: string = UserPreferenceConstants.OrphanContainerDetailSearch;
  searchResults: any[] = [];
  doStatusOptions: any[] = [];
  columns: any = {};
  detailColumns: any = {};
  isSearchFormOpen: boolean = true;
  searchParams: any;
  value: string;

  constructor(
    injector: Injector,
    private containerService: ContainerService,
    private dropdownOptionsService: DropdownOptionsService,
    private translate: TranslateService
  ) {

    super(injector);

    this.columns = [
      { field: 'facility', header: 'UnallocatedContainer.MainTable.Facility'},
      { field: 'carSeqNo', header: 'UnallocatedContainer.MainTable.AssignDate' },
      { field: 'pickupLocation', header: 'UnallocatedContainer.MainTable.PickUp' },
      { field: 'containerTypeConstraint', header: 'UnallocatedContainer.MainTable.ContainerPeriod' },
      { field: 'isExport', header: 'UnallocatedContainer.MainTable.ContainerShippingType' },
      { field: 'forwarder', header: 'UnallocatedContainer.MainTable.ContainerForwarder' },
      { field: 'consigneeKey', header: 'UnallocatedContainer.MainTable.ContainerCustomer' },
      { field: 'createDt', header: 'UnallocatedContainer.MainTable.CreationTime', dataType: 'date' },
      { field: 'createUser', header: 'UnallocatedContainer.MainTable.Creator' }
    ];

    this.detailColumns = [
      { field: 'carTrip', header: 'UnallocatedContainer.SubTable.CarNumber'},
      { field: 'bookingNo', header: 'UnallocatedContainer.SubTable.BookingNo'},
      { field: 'doNo', header: 'UnallocatedContainer.SubTable.DO'},
      { field: 'invoiceNo', header: 'UnallocatedContainer.SubTable.DOInvoice'},
      { field: 'consigneeKey', header: 'UnallocatedContainer.SubTable.CustomerCode'},
      { field: 'consigneeCompany', header: 'UnallocatedContainer.SubTable.CustomerName'},
      { field: 'orgName', header: 'UnallocatedContainer.SubTable.LoadOrderComp'},
      { field: 'shipCorpName', header: 'UnallocatedContainer.SubTable.ShipOutComp'},
      { field: 'letterHeadOrgName', header: 'UnallocatedContainer.SubTable.LetterHeadComp'},
      { field: 'doStatus', header: 'UnallocatedContainer.SubTable.DOStatus'},
      { field: 'cartonCnt', header: 'UnallocatedContainer.SubTable.CartonCount'},
      { field: 'totalGrossWeight', header: 'UnallocatedContainer.SubTable.GrossWeight', dataType: 'number'},
      { field: 'totalNetWeight', header: 'UnallocatedContainer.SubTable.NetWeight', dataType: 'number'},
      { field: 'volumeWeight', header: 'UnallocatedContainer.SubTable.Volume', dataType: 'number'}
    ];

    this.searchParams = {
      doNos: []
    }

    this.value = "";
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();
    this.searchBtnClick(null);

    this.dropdownOptionsService.getDOStatusOptions()
      .subscribe({
        next: (options: any[]) => {
          this.doStatusOptions = options.map(x => ({ label: x.optionDesc, value: x.optionCode }));
        }
      });
  }


  searchBtnClick(event: any): void{
    this.isLoading = true;

    this.containerService.getOrphanHeader(this.searchParams).subscribe({
      next: result => {
        this.searchResults = result;
        this.isLoading = false;
      },
      error: err => {
        this.toastErrorMessage(err.error);
        this.isLoading = false;
      },
      complete: () => {
        this.isLoading = false;
      }
    });
  }

  /**
   * DO number field add event.
   * @param event p-chips onAdd event.
   */
   doNoChipsAdd(event: any): void {
    const value: string = event.value;
    const parsedValues: string[] = value.split('\r\n').filter(x => isNullOrEmpty(x) === false && x !== '\r\n');
    this.searchParams.doNos.splice(this.searchParams.doNos.indexOf(value));
    this.searchParams.doNos = this.searchParams.doNos.concat(parsedValues);
  }

  formatTableTitle(booking: any): String {
    this.translate.get('UnallocatedContainer.SubTable.UnallocatedDetails').subscribe(str =>{
      this.value = str;
    })
    return this.value;
  }

  searchDetailClick(event: any): void{
    const rowData = event.rowData;
    const isClosed = event.expanded;

    if (isClosed) {
      return;
    }

    this.loader.show();

    this.containerService.getOrphanDetail(rowData.seqNo).subscribe({
      next: result => {

        this.searchResults.forEach((x: any) => {
          x.details = [];
        });

        rowData.details = [...result].map((x: any) => {
          return x;
        });

        this.loader.hide();
      },
      error: (err: HttpErrorResponse) => {
        this.toastErrorMessage(err.error);
        this.loader.hide();
      }
    });
  }

}
